import { Component, OnInit } from "@angular/core";
import { StatusCliente } from "./model/status.model";
import { StatusConfigListComponent } from "./components/status-message-list/status-message-list.component";
import { StatusConfigFormComponent } from "./components/status-message-form/status-config-form.component";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { CustomMessageListComponent } from "./components/custom-message-list/custom-message-list.component";
import { AuthService } from "src/app/core/services/auth/auth.service";

@Component({
  selector: "app-status-config",
  // standalone: true,
  // imports: [
  //   StatusConfigListComponent,
  //   CustomMessageListComponent,
  //   NgbNavModule,
  //   CommonModule,
  // ],
  templateUrl: "./status-config.component.html",
  styleUrl: "./status-config.component.scss",
})
export class StatusConfigComponent implements OnInit {
  breadCrumbItems!: Array<{}>;

  //permissão
  podeVer: boolean = false;

  status: StatusCliente[] = [];
  isLoading: boolean = true;
  
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Call Center" },
      { label: "Configuração", active: true },
    ];

    this.permissaoAdicionarUsuario();
  }

  openModal(status?: StatusCliente) {}

  permissaoAdicionarUsuario(): void {
    this.podeVer = this.authService.verificarPermissao('Call_Configuracoes', 'Ver')
  }
}
